import RisksView from "./risks-view.jsx";

export default RisksView